import { render, staticRenderFns } from "./BrandsComponent.vue?vue&type=template&id=21a8dae8"
import script from "./BrandsComponent.vue?vue&type=script&lang=js"
export * from "./BrandsComponent.vue?vue&type=script&lang=js"
import style0 from "./BrandsComponent.vue?vue&type=style&index=0&id=21a8dae8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports